
export class AgendaResponse {
  selectedHistoryId: number = 0;
  plannedOnDate!: Date | string;
  agendaReference: string = '';
  status: string = '';
  agendaHistoryAuditList: AgendaHistoryAudit[] = [];
}

export class AgendaHistoryAudit {
  agendaHistoryAuditId: number = 0;
  plannedOnDate: Date = new Date();
  agendaReference: string = '';
  createdDate: Date = new Date();
  status: string = '';
}
